import { Injectable }               from '@angular/core';
import { Http }                     from '@angular/http';
import { Globals }                  from '../common/globals';
import { AuthHttp }                 from 'angular2-jwt';
import { Observable }               from 'rxjs/Observable';
import { CommonService }            from './common.service';
import { MatSnackBar }               from '@angular/material';

@Injectable()
export class TrainCycleProductService {

    private _commonService: CommonService;
    constructor(public authHttp: AuthHttp, private http: Http, private globals: Globals, public snackbar: MatSnackBar) {
        this._commonService = new CommonService(authHttp, http, globals, 'trainCycleProduct', snackbar);
    }

    public getItems(cycleUID: string): Observable<any> {
        return this._commonService.get('/products/' + cycleUID).map(p => {
            p.cycleUID = cycleUID;
            return p;
        });
    }

    public updateItem(id: string, item: any): Observable<any> {
       return this._commonService.updateItem(id, item);
    }

    public deleteItem(id: string): Observable<any> {
        return this._commonService.deleteItem(id);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/train-cycle-product.service.ts